export default __webpack_public_path__ + "static/c07-5de8aa4cd3c8b395092299ef5a5990bb.png";